import includedZipCodes from '~/shared/constants/burdZipcodes.json';

export const ZIP_REGEX = /^\d{4}$/;

export const includedZipSet = new Set<string>(includedZipCodes);
